import { createContext } from 'react';

import type { PaymentType } from 'src/app/shared/utils/payments';

export type AvailablePaymentMethodsState = { paymentMethods: PaymentType[] };

export const AvailablePaymentMethodsContext = createContext<AvailablePaymentMethodsState>({ paymentMethods: [] });
